import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

// const FileDownload = require('js-file-download');

const urlAPI = environment.getApi('geometryUser');

export const check = () => useBasicAuth.checkToken();

// Axios({
//   url: 'http://localhost/downloadFile',
//   method: 'GET',
//   responseType: 'blob', // Important
// }).then((response) => {
//     FileDownload(response.data, 'report.csv');
// });

export const exportCSV = (id) => 
  axios.get(urlAPI + "/export/csv/" + id, environment.HEADER_CSV)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findById = (id) => 
  axios.get(urlAPI + "/findById/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequerimento = () => 
  axios.get(urlAPI + "/findAllRequerimento", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequerimentoGeometry = () => 
  axios.get(urlAPI + "/findAllRequerimentoGeometry", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllBuffer = () => 
  axios.get(urlAPI + "/findAllBuffer", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllBufferGeometry = () => 
  axios.get(urlAPI + "/findAllBufferGeometry", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequerimentoBuffer = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const saveRequirement = (obj) => 
  axios.post(urlAPI + "/saveRequirement", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    return null;
  });

export const updateRequirement = (obj) => 
  axios.post(urlAPI + "/updateRequirement/", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const saveBuffer = (obj) => 
  axios.post(urlAPI + "/saveBuffer", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    return null;
  });

export const updateBuffer = (obj) => 
  axios.post(urlAPI + "/updateBuffer/",  JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });


  
export const findAllBuffersByUser = (user) => 
  axios.get(urlAPI + "/findAllBuffersByUser/" + user.id, environment.HEADER) 
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllRequirementsByUser = (user) => 
  axios.get(urlAPI + "/findAllRequirementsByUser/" + user.id, environment.HEADER) 
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
